function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0833 54.1667H37.9166V10.8334H27.0833V54.1667ZM10.8333 54.1667H21.6666V32.5H10.8333V54.1667ZM43.3333 54.1667V24.375H54.1666V54.1667H43.3333Z",
  fill: "url(#paint0_linear)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 32.4999,
  y1: 10.8334,
  x2: 32.4999,
  y2: 54.1667,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0099BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#007A6A"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/StatPollIcon.039458f4.svg";
export { SvgComponent as ReactComponent };